module.exports = "https://web-assets.ifttt.com/packs/media/icons/cold-892f1c9a.png";